import React from "react";
import "./PageErreur.css";

const PageErrer: React.FC = () => {
  const handleRetour = () => {
    window.history.back();
  };

  const handleConnecter = () => {
    // replace with your login route
    window.location.href = "/connecter_compte";
  };

  return (
    <div className="access-container-erreur">
      <div className="access-box-erreur">
        <div className="access-icon-erreur"><i className="bi bi-exclamation-triangle-fill"></i></div>
        <h2 className="access-title-erreur">Accès Refusé</h2>
        <p className="access-subtitle-erreur">Vous n'êtes pas connecté</p>
        <p className="access-text-erreur">
          Pour accéder à cette page, vous devez être connecté à votre compte.
        </p>
        <div className="access-buttons-erreur">
          <button className="btn-retour-erreur" onClick={handleRetour}>
            Retour
          </button>
          <button className="btn-connecter-erreur" onClick={handleConnecter}>
            Se connecter
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageErrer;
